// Test utility for deferred deep linking
// This can be used in development to simulate the deferred deep link scenario

import { deferredDeepLinkService } from './deferredDeepLink';

export class DeferredDeepLinkTester {
  static simulateAppStoreInstallation(uid: string) {
    console.log('🧪 Simulating app store installation with UID:', uid);
    
    // Clear any existing data
    localStorage.removeItem('app_has_launched_before');
    localStorage.removeItem('pendingInviteUid');
    localStorage.removeItem('deferredInviteUid');
    deferredDeepLinkService.clearDeferredData();
    
    // Simulate install referrer data
    localStorage.setItem('install_referrer_data', JSON.stringify({ uid }));
    
    // Simulate deferred deep link data
    deferredDeepLinkService.simulateInstallReferrer(uid);
    
    console.log('✅ Simulation complete. Next app launch should open to initialize page with UID:', uid);
  }
  
  static simulateFreshInstall() {
    console.log('🧪 Simulating fresh app installation...');
    
    // Clear all data as if it's a fresh install
    localStorage.removeItem('app_has_launched_before');
    localStorage.removeItem('pendingInviteUid');
    localStorage.removeItem('deferredInviteUid');
    localStorage.removeItem('install_referrer_data');
    localStorage.removeItem('deferred_deep_link_data');
    localStorage.removeItem('inviteTimestamp');
    
    deferredDeepLinkService.clearDeferredData();
    
    console.log('✅ Fresh install simulation complete. App should open to login page.');
  }
  
  static getCurrentState() {
    const state = {
      hasLaunchedBefore: localStorage.getItem('app_has_launched_before'),
      pendingUid: localStorage.getItem('pendingInviteUid'),
      deferredUid: localStorage.getItem('deferredInviteUid'),
      installReferrerData: localStorage.getItem('install_referrer_data'),
      deferredData: localStorage.getItem('deferred_deep_link_data'),
      inviteTimestamp: localStorage.getItem('inviteTimestamp'),
      serviceData: deferredDeepLinkService.getDeferredData()
    };
    
    console.log('📊 Current deferred deep link state:', state);
    return state;
  }
}

// Make it available globally for testing in development
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  (window as any).DeferredDeepLinkTester = DeferredDeepLinkTester;
  console.log('🧪 DeferredDeepLinkTester available globally. Use DeferredDeepLinkTester.simulateAppStoreInstallation("test-uid") to test.');
}
